import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';

@Component({
  selector: 'mb-atom-carousel-preview',
  imports: [],
  templateUrl: './carousel-preview.html',
  styleUrl: './carousel-preview.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselPreview {
  readonly images = input.required<
    {
      width: number;
      height: number;
      s3_key: string;
      s3_url: string;
      s3_bucket: string;
    }[]
  >();

  readonly selectedIndex = signal(0);

  /** Flex basis each slide: 100% / n of the track (track is n × viewport wide). */
  readonly slideBasisPercent = computed(() => {
    const n = this.images().length;
    return n > 0 ? 100 / n : 100;
  });

  /** Track width as % of viewport (overflow container). */
  readonly trackWidthPercent = computed(() => this.images().length * 100);

  /** translateX(-index * (100/n)%) — prev moves track right (higher index offset decreases), next moves left. */
  readonly trackTransform = computed(() => {
    const n = this.images().length;
    if (n === 0) {
      return 'translateX(0)';
    }
    const pct = (this.selectedIndex() * 100) / n;
    return `translateX(-${pct}%)`;
  });

  nextSlide(direction: number): void {
    const len = this.images().length;
    if (len <= 1) {
      return;
    }
    if (direction === -1) {
      if (this.selectedIndex() === 0) {
        this.selectedIndex.set(len - 1);
      } else {
        this.selectedIndex.update((i) => i - 1);
      }
    } else {
      if (this.selectedIndex() === len - 1) {
        this.selectedIndex.set(0);
      } else {
        this.selectedIndex.update((i) => i + 1);
      }
    }
  }

  selectSlide(index: number): void {
    if (index >= 0 && index < this.images().length) {
      this.selectedIndex.set(index);
    }
  }
}
